<template>
  <div class="wrapper" ref="video">
    <div class="overlay" @click="close()"></div>
    <div class="close" @click="close()">x</div>
    <div ref="video-modal" class="video-modal">
      <iframe width="853" height="480" :src="'https://www.youtube-nocookie.com/embed/'+video" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'videoModal',
  components: {
    
  },
  data() {
    return {
      state: this.$store.state,
      ui: {

      }
    }
  },
  props: {
    video: String
  },
  mounted() {
    document.body.appendChild(this.$refs.video)
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="stylus" scoped>
iframe {
  max-width:100%
  max-height:90%
}
.wrapper {
  display:flex;
  flex-direction:column;
  justify-content: center;
  align-items:center;
  position:fixed;
  width:100%;
  height:100%;
  top:0;
  left:0
  z-index:200
}
.overlay {
  background-color:rgba(0,0,0,0.8)
  width:100%
  height:100%
  position:fixed
  z-index:999
  left:0
  top:0
}
.video-modal {
  z-index:1000
  height:auto
  width:auto
  max-width: 1200px
  max-height: 800px
  background-color: transparent
  //box-shadow: 0 0 20px 10px rgba(0,0,0,0.4)
  color:white
}
.close {
  position: fixed
  z-index:1001
  top:2%
  right 4%
  color:white
  font-size: 60px
  font-weight:bold
  line-height:1
  cursor:pointer
}
.title {
  text-align:center
  margin-top:10%
  font-family: 'FedraSerifAPro'
  font-size:48px
  font-weight:bold
}
.text {
  text-align:center
  margin-top:8%
  font-size:15px
}
.footer {
  text-align:center
  margin-top:15%
  font-size:15px
  font-weight:bold
}

</style>